/* tslint:disable */
/* eslint-disable */
/**
 * predictonco-backend API
 * predictonco-backend API
 *
 * The version of the OpenAPI document: 1.0.3
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Mutation
 */
export interface Mutation {
    /**
     * 
     * @type {number}
     * @memberof Mutation
     */
    position: number;
    /**
     * 
     * @type {string}
     * @memberof Mutation
     */
    wt: string;
    /**
     * 
     * @type {string}
     * @memberof Mutation
     */
    mut: string;
    /**
     * 
     * @type {boolean}
     * @memberof Mutation
     */
    essential: boolean;
    /**
     * 
     * @type {string}
     * @memberof Mutation
     */
    domainType: string;
}

/**
 * Check if a given object implements the Mutation interface.
 */
export function instanceOfMutation(value: object): value is Mutation {
    if (!('position' in value) || value['position'] === undefined) return false;
    if (!('wt' in value) || value['wt'] === undefined) return false;
    if (!('mut' in value) || value['mut'] === undefined) return false;
    if (!('essential' in value) || value['essential'] === undefined) return false;
    if (!('domainType' in value) || value['domainType'] === undefined) return false;
    return true;
}

export function MutationFromJSON(json: any): Mutation {
    return MutationFromJSONTyped(json, false);
}

export function MutationFromJSONTyped(json: any, ignoreDiscriminator: boolean): Mutation {
    if (json == null) {
        return json;
    }
    return {
        
        'position': json['position'],
        'wt': json['wt'],
        'mut': json['mut'],
        'essential': json['essential'],
        'domainType': json['domainType'],
    };
}

export function MutationToJSON(json: any): Mutation {
    return MutationToJSONTyped(json, false);
}

export function MutationToJSONTyped(value?: Mutation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'position': value['position'],
        'wt': value['wt'],
        'mut': value['mut'],
        'essential': value['essential'],
        'domainType': value['domainType'],
    };
}

